














































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  SubTitle,
  FormLabel,
  FormInput,
  FormCheckbox,
  FormSelect,
  FormButton
} from "@/components/index.ts";
import { IGoodsItem, IPayment, IUser, ITopup } from "@/interface";
import {
  getGameAssets,
  getServerList,
  ValidateUser,
  TopUp
} from "@/api/index";
import { ConfigModule, MaskModule } from "@/store/index";
import { compatibleImgUrl } from "@/utils/common";

@Component({
  components: {
    SubTitle,
    FormLabel,
    FormInput,
    FormCheckbox,
    FormSelect,
    FormButton
  }
})
export default class Shop extends Vue {
  /* -------------- data ------------- */
  otherClickDom = []; // 点击不会触发clickOutSideEvent事件元素列表
  ASSETS_URL = process.env.VUE_APP_ASSETS_URL;

  gameId = ""; // 当前游戏id
  gameName = ""; // 游戏名字
  gameThumbnail = ""; // 游戏缩略图
  downloadLinkText = ""; // 下载标题文本
  referenceLinkText = ""; // 参考标题文本
  referenceText = ""; // 参考连接文本
  downList = []; // 下载列表
  guideImg = ""; // 引导图片地址
  verificationLabel = ""; // 验证用户信息标题
  selectItemLabel = ""; // 选择商品标题
  paymentLabel = ""; // 支付方式标题
  formLabelServer = ""; // 表单标签文本（服务器）
  formLabelUid = ""; // 表单标签文本（玩家uid）
  formLabelIgn = ""; // 表单标签文本（游戏内名字）
  confirmText = ""; // 确认按钮文本
  agreementText = ""; // 用户同意文本
  agreementLinkText = ""; // 用户同意链接文本
  confirmFormText = ""; // 充值按钮文本
  verifyTip = ""; // 验证提示文本
  gameShopClosedText = ""; // 当前游戏在该地区未开放文本
  rechargeNotesText = ""; // 当前游戏充值注意事项

  goodsList: IGoodsItem[] = []; // 商品列表
  serverList = []; // 服务器列表

  /**
   * 玩家购买信息
   */
  serverId = ""; // 充值服务器
  userId = ""; // 玩家uid
  ign = ""; // 玩家游戏名
  goodsId = ""; // 商品id
  goodsMoney = 0; // 商品价格
  paymentType = ""; // 支付方式
  isAgree = false; // 是否同意条款

  currencySymbol = ""; // 支付货币符号

  /* 提示 */
  verifyPlayerInfoTip = ""; // 玩家信息验证提示
  verifyGoodsTip = ""; // 商品信息验证提示
  verifyPaymenTip = ""; // 支付方式验证提示

  /* -------------- hook ------------- */
  async created () {
    // 游戏Id
    // this.gameId = this.$route.params.gameId;
    this.gameId = "heavenburnsred";
    ConfigModule.setGameId(this.gameId);

    await this.initAssets();

    ConfigModule.setIgnoreOnbeforeunload(false);
  }

  mounted () {
    window.onbeforeunload =  (e: any) => {   // eslint-disable-line
      if (!this.ignoreOnbeforeunload) {
        e = e || window.event;
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = "Give up on recharging and leave the current page directly?";
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "Give up on recharging and leave the current page directly?";
      }
      ConfigModule.setIgnoreOnbeforeunload(false);
    };
  }

  destroyed () {
    window.onbeforeunload = null;
  }

  /* -------------- watch ------------- */
  @Watch("lang")
  async onChangeLang (val: string, oldVal: string) {
    if (oldVal) {
      // 清除页面资源
      this.clearAssets();
      // 获取网站资源
      this.initAssets();
    }
  }

  @Watch("goodsId")
  onChangeGoodsId (val: string) {
    this.paymentType = "";
  }

  /* -------------- computed ------------- */
  get lang () {
    // 已选语言key
    return ConfigModule.lang;
  }

  get ignoreOnbeforeunload () {
    // 是否忽略离开商店页面前提示
    return ConfigModule.ignoreOnbeforeunload;
  }

  get paymentList () {
    // 支付方式
    if (this.goodsId) {
      const goodsItem = this.goodsList.find((item: IGoodsItem) => item.product_id === this.goodsId);
      if (goodsItem) {
        return goodsItem.product_payment;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  /* -------------- methods ------------- */

  /**
   * @description: 兼容图片地址
   */
  compatibleImgUrl (imgUrl: string) {
    return compatibleImgUrl(imgUrl);
  }

  /**
   * @description: 初始化页面资源
   */

  async initAssets () {
    try {
      /* 请求页面资源 */
      const getSiteAssetsRet: any = await ConfigModule.getSiteAssets(this.lang);    // eslint-disable-line
      // 页面文本
      const siteAssets = getSiteAssetsRet.payload.siteAssets.data.asset;

      this.selectItemLabel = siteAssets.categoryForSelectItemText;
      this.paymentLabel = siteAssets.categoryForPaymentMethodText;
      this.formLabelServer = siteAssets.categoryForSelectServerText;
      this.formLabelUid = siteAssets.categoryForUIDText;
      this.formLabelIgn = siteAssets.categoryForIGNTitle;
      this.confirmText = siteAssets.categoryForConfirmText;
      this.confirmFormText = siteAssets.categoryForRechargeButtonText;
      this.verifyTip = siteAssets.categoryForAgreementCheckText;
      this.downloadLinkText = siteAssets.categoryForDownloadLinkTitle;
      this.referenceLinkText = siteAssets.categoryForFriendLinkTitle;
      this.verificationLabel = siteAssets.categoryForVerificationUserTitle;
      this.agreementText = siteAssets.categoryForUserAgreementText;
      this.agreementLinkText = siteAssets.categoryForUserAgreementLinkText;
      this.gameShopClosedText = siteAssets.categoryForFailText;

      /* 请求游戏页面内容 */
      const getGameAssetsRet: any = await getGameAssets(this.lang, this.gameId);    // eslint-disable-line
      console.log("[Shop]-[getGameAssetsRet]", getGameAssetsRet);

      // 游戏信息
      const targetInfo = getGameAssetsRet.payload.data.targetInfo;
      this.currencySymbol = targetInfo.currency_symbol;   // eslint-disable-line

      // 游戏详情信息
      const targetAsset = getGameAssetsRet.payload.data.targetAsset;

      if (Object.keys(targetAsset).length === 0) {
        MaskModule.alertMask(this.gameShopClosedText);
        MaskModule.afterClosedEvent(() => {
          this.$router.push({ path: "/" });
        });
        return;
      }

      if (targetAsset.categoryForRechargeNotes) {
        this.rechargeNotesText = targetAsset.categoryForRechargeNotes;
      }

      if (targetAsset.categoryForTargetDetail) {
        this.gameName = targetAsset.categoryForTargetDetail.name;
        if (targetAsset.categoryForTargetDetail.items[0].imgInfo[0]) {
          this.gameThumbnail = targetAsset.categoryForTargetDetail.items[0].imgInfo[0].bannerUrl;
        }
      }
      this.referenceText = targetAsset.categoryForFriendLinkContent;
      if (targetAsset.categoryForDownloadLinkDetail) {
        this.downList = targetAsset.categoryForDownloadLinkDetail.items;
      }
      if (targetAsset.categoryForSearchUID) {
        if (targetAsset.categoryForSearchUID.items[0].imgInfo[0]) {
          this.guideImg = targetAsset.categoryForSearchUID.items[0].imgInfo[0].bannerUrl;
        }
      }
      if (targetAsset.categoryForShopItem) {
        this.goodsList = targetAsset.categoryForShopItem.items;
      }

      /* 获取服务器列表 */
      const getServerListRet: any = await getServerList(this.gameId);   // eslint-disable-line
      console.log("[Shop]-[getServerListRet]", getServerListRet);
      this.serverList = getServerListRet.payload;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * @description: 清除页面资源,重置商品参数
   */

  clearAssets () {
    this.gameName = "";
    this.gameThumbnail = "";
    this.downloadLinkText = "";
    this.referenceLinkText = "";
    this.referenceText = "";
    this.downList = [];
    this.verificationLabel = "";
    this.guideImg = "";
    this.goodsList = [];
    this.agreementText = "";
    this.agreementLinkText = "";

    this.selectItemLabel = "";
    this.paymentLabel = "";
    this.formLabelServer = "";
    this.formLabelUid = "";
    this.formLabelIgn = "";
    this.confirmText = "";
    this.confirmFormText = "";
    this.verifyTip = "";
    // 重置服务器列表
    this.serverList = [];
    // 重置商品参数
    this.goodsId = "";
    this.goodsMoney = 0;
  }

  /**
   * @description: 显示下拉框
   */

  showOptions () {
    this.$set(this.otherClickDom, 0, this.$refs["form-server-button"]);
    (this.$refs["form-server-select"] as FormSelect).showOptions();
  }

  /**
   * @description: 验证用户信息
   */

  async ValidateUser () {
    try {
      if ((this.serverList.length > 0 && this.serverId === "") || this.userId === "") {
        this.verifyPlayerInfoTip = this.verifyTip;
        return;
      } else {
        this.verifyPlayerInfoTip = "";
      }

      const userinfo: IUser = {
        userId: this.userId,
        serverId: this.serverId,
        gameId: this.gameId
      };
      const ValidateUserRet: any = await ValidateUser(userinfo);    // eslint-disable-line
      console.log("[Shop]-[ValidateUserRet]", ValidateUserRet);
      if (ValidateUserRet.meta.isSuccess) {
        // 查询到用户信息
        this.ign = ValidateUserRet.payload.userName;
      } else {
        // 未查到用户信息
        MaskModule.alertMask("未查到用户信息");
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * @description: 选择商品
   */

  selectGoodsItem (item: IGoodsItem) {
    this.goodsId = item.product_id;
    this.goodsMoney = item.product_price;
  }

  /**
   * @description: 选择支付方式
   */

  selectPaymentType (item: IPayment) {
    if (this.goodsId) {
      this.paymentType = item.payment_name;
    }
  }

  /**
   * @description: 切换同意条款状态
   */

  toggleIsAgree () {
    this.isAgree = !this.isAgree;
  }

  /**
   * @description: 确认提交表单，充值请求
   */

  async confirmForm () {
    try {
      if ((this.serverList.length > 0 && this.serverId === "") || this.userId === "") {
        this.verifyPlayerInfoTip = this.verifyTip;
      } else {
        this.verifyPlayerInfoTip = "";
      }

      if (this.goodsId === "") {
        this.verifyGoodsTip = this.verifyTip;
      } else {
        this.verifyGoodsTip = "";
      }

      if (this.paymentType === "" || !this.isAgree) {
        this.verifyPaymenTip = this.verifyTip;
      } else {
        this.verifyPaymenTip = "";
      }

      if (
        this.verifyPlayerInfoTip === "" &&
        this.verifyGoodsTip === "" &&
        this.verifyPaymenTip === ""
      ) {
        // 通过验证，请求充值
        window.gtag("event", `${this.gameId}_purchaseclick`);

        const topupItem: ITopup = {
          userId: this.userId,
          serverId: this.serverId,
          gameId: this.gameId,
          lang: this.lang,
          itemId: this.goodsId,
          paymentMethod: this.paymentType
        };

        const topUpRet:any = await TopUp(topupItem);    // eslint-disable-line
        console.log("[Shop]-[topUpRet]", topUpRet);
        if (topUpRet.meta.isSuccess) {
          ConfigModule.setIgnoreOnbeforeunload(true);
          window.location.href = topUpRet.payload.redirectUrl;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
}
